import { render, staticRenderFns } from "./OneColumn.vue?vue&type=template&id=e0cf6a12"
import script from "./OneColumn.vue?vue&type=script&lang=ts"
export * from "./OneColumn.vue?vue&type=script&lang=ts"
import style0 from "./OneColumn.vue?vue&type=style&index=0&id=e0cf6a12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports